(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/nav-menu/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/nav-menu/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.poker_react = svs.poker_react || {};
svs.poker_react.components = svs.poker_react.components || {};
svs.poker_react.components.common = svs.poker_react.components.common || {};
svs.poker_react.components.common.constants = svs.poker_react.components.common.constants || {};
svs.poker_react.components.common.constants.MenuTabTypes = svs.poker_react.components.common.constants.MenuTabTypes || {};


 })(window);